import { __assign, __spreadArrays } from "tslib";
import React, { useContext, useMemo } from 'react';
import c from 'classnames';
import { CommentContext } from '../CommentContext';
import { sortPapiBadge } from '../../../coreBadge/utils';
import { ResourceType } from '../../../types/resource';
import Badge from '../../../Badge';
import Flex from '../../../Flex';
import CoreBadgeButton from '../../../coreBadge/CoreBadgeButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import CustomNotificationProvider from '../../../Notifications/CustomNotificationContext';
import { getCommentNotificationQueue } from '../../utils';
import s from './CommentBadges.scss';
var CommentBadges = function (_a) {
    var className = _a.className;
    var comment = useContext(CommentContext).comment;
    var badges = useMemo(function () {
        if (!Array.isArray(comment.awardedBadges)) {
            return [];
        }
        var sorted = __spreadArrays(comment.awardedBadges);
        sorted.sort(sortPapiBadge);
        return sorted;
    }, [comment.awardedBadges]);
    return (React.createElement(CustomNotificationProvider, { queueName: getCommentNotificationQueue(comment) },
        React.createElement(Flex, { className: className }, badges.map(function (badge, index) {
            return badge.stackCount && (React.createElement(CoreBadgeButton, { className: c(s['badge-button'], index !== badges.length - 1 && s['badge-button-with-margin']), key: badge.name, type: badge.name, badges: badges, recipient: {
                    typeId: ResourceType.COMMENT,
                    itemId: comment.commentId,
                    user: comment.user,
                }, biData: {
                    evid: BiEventType.BADGE_STATISTICS_CLICK,
                    sectionname: 'comments',
                    typeid: ResourceType.COMMENT,
                    itemid: comment.commentId,
                } },
                React.createElement(Badge, __assign({ className: s['badge'] }, badge)),
                " ",
                badge.stackCount));
        }))));
};
CommentBadges.displayName = 'CommentBadges';
export default CommentBadges;
//# sourceMappingURL=CommentBadges.js.map